export default __webpack_public_path__ + "static/media/video7.4b2c9675.webp";